export const createGrafanaEvent = (type) =>
    ({ sourceInfo = {} } = {}) => {
        const platform = getPlatform(sourceInfo);

        return `${platform}.${type}`;
    };

const getPlatform = ({ isTouch }) => isTouch ? 'mobile' : 'desktop';
